import { useEffect, useRef } from "react";
import gsap from "gsap";

export default function AnimatedText() {
  const textRef = useRef(null);
  const played = useRef(false);

  const text =
    "Vous portez un projet qui mérite d’être remarqué. Maestrom conçoit des sites premium qui allient design immersif et performance. Mettez en valeur vos services, affirmez une identité forte et offrez à vos visiteurs une expérience qui marque les esprits";

  useEffect(() => {
    if (!textRef.current) return;

    const chars = Array.from(
      textRef.current.querySelectorAll("span.char")
    );

    gsap.set(chars, { y: 20, opacity: 0 }); // état initial

    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !played.current) {
        played.current = true;
        gsap.to(chars, {
          y: 0,
          opacity: 1,
          stagger: 0.03,
          duration: 0.8,
          ease: "power3.out",
        });
        io.disconnect();
      }
    }, { threshold: 0.2 });

    io.observe(textRef.current);
    return () => io.disconnect();
  }, []);

  return (
    <p className="text f36" ref={textRef}>
      {text.split(/(\s+)/).map((part, i) =>
        part.trim() ? (
          <span key={i} className="char" style={{ display: "inline-block", whiteSpace: "pre" }}>
            {part}
          </span>
        ) : (
          <span key={i} className="space" style={{ whiteSpace: "pre" }}>
            {part}
          </span>
        )
      )}
    </p>
  );
}
